export const defaultState = [
  // "austin"
];

const inputs = (state = defaultState, action) => {
  switch (action.type) {
    case "ON_INPUT_CHANGE":
      return action.query;
    default:
      return state;
  }
};

export default inputs;



// WEBPACK FOOTER //
// ./src/reducers/inputs.js